import React from 'react';
import SearchWordListSearchBox from '../SearchWordListSearchBox';
import SearchWordList from '../SearchWordList';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { SEARCH_WORD_LIST_SORT_OPTION_MODEL } from '../../../../store/modules/searchWord/models';

const SearchWordListWrap = (props) => {
  const { setData, searchWordList, getList, getSearchWordListExcelDownload } = props;

  return (
    <div className="search-word-list-wrap">
      <SearchWordListSearchBox
        setData={(data) => {
          setData({
            path: ['searchWordList', 'searchData', ...data.path],
            value: data.value,
          });
        }}
        searchData={searchWordList.searchData}
        getList={getList}
      />

      <SearchWordList
        searchWordList={searchWordList.list}
        initialOption={{
          sortOption: SEARCH_WORD_LIST_SORT_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        }}
        sortOption={searchWordList.sortOption}
        pagination={searchWordList.pagination}
        getList={getList}
        getSearchWordListExcelDownload={getSearchWordListExcelDownload}
      />
    </div>
  );
};

export default SearchWordListWrap;
